import { useLocation } from '@reach/router'
import { graphql, useStaticQuery } from 'gatsby'
import PropTypes from 'prop-types'
import React from 'react'
import { Helmet } from 'react-helmet'

const SEO = ({ description, lang, meta, title, frontpage }) => {
  const location = useLocation()

  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description

  return (
    <Helmet
      title={title}
      titleTemplate={
        frontpage ? `Digitalagentur ${site.siteMetadata.title}` : `%s - Digitalagentur ${site.siteMetadata.title}`
      }
      link={[
        {
          rel: 'canonical',
          href: `https://www.neoskop.de${location.pathname}`
        }
      ]}
      meta={[
        {
          name: 'viewport',
          content: 'width=device-width, initial-scale=1.0'
        },
        {
          name: 'description',
          content: metaDescription
        },
        {
          property: 'og:title',
          content: title
        },
        {
          property: 'og:description',
          content: metaDescription
        },
        {
          property: 'og:type',
          content: 'website'
        }
      ].concat(meta)}
    >
      <script defer data-domain="neoskop.de" src="/js/plausible.js"></script>
    </Helmet>
  )
}

SEO.propTypes = {
  frontpage: PropTypes.bool,
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired
}

SEO.defaultProps = {
  lang: 'en',
  meta: [],
  description: '',
  frontpage: false
}

export default SEO
